import { z } from "zod"

import { HeaderButtonNotifications } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonNotifications"
import { HeaderButtonProfile } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonProfile"
import { HeaderButtonReferAFriend } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonReferAFriend"
import { HeaderButtonSupport } from "@/components/generic/HeaderNavBar/components/HeaderNavButton/components/HeaderButtonSupport"

const HeaderButtonTypeEnum = z.enum([
  "ReferAFriend",
  "SupportChat",
  "Notifications",
  "Profile",
])
type THeaderButtonType = z.infer<typeof HeaderButtonTypeEnum>

interface HeaderNavBarButtonProps {
  type: THeaderButtonType
}

export function HeaderNavBarButton({ type }: HeaderNavBarButtonProps) {
  switch (type) {
    case HeaderButtonTypeEnum.Enum.ReferAFriend:
      return <HeaderButtonReferAFriend />
    case HeaderButtonTypeEnum.Enum.Notifications:
      return <HeaderButtonNotifications />
    case HeaderButtonTypeEnum.Enum.SupportChat:
      return <HeaderButtonSupport />
    case HeaderButtonTypeEnum.Enum.Profile:
      return <HeaderButtonProfile />
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>
  }
}
